import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Image, Layout, Menu } from "antd";
import { useLocation } from "react-router-dom";
import logo2 from "../../../../assets/logo2.png";
import "../AuthedLayout.less";
import useSideNav from "./useSideNav";
const { Sider } = Layout;

/// This component is intended to replace the current side menu
/// however, I have not yet figured out what the best way to handle the modules
/// e.g., Utility, Payroll, Tax etc., and allow us to build the menu dynamically
/// based on the licensing of the respective client.
///
/// So, for now, it will be a hard coded menu.

const BackOfficeSideMenu = ({ ...props }) => {
  const { buildSideMenu, toggle, menuCollapsed } = useSideNav();
  const location = useLocation();

  return (
    <Sider width={250} collapsedWidth={0} breakpoint="md" trigger={<FontAwesomeIcon className="erp-menu-trigger" icon={["fas", "bars"]} />} collapsible collapsed={menuCollapsed} onCollapse={toggle}>
      <Image width={250} style={{ margin: "auto", textAlign: "center" }} preview={false} src={logo2} />
      <Menu theme="light" mode="inline" defaultSelectedKeys={["/"]} selectedKeys={[location.pathname]}>
        {buildSideMenu()}
      </Menu>
    </Sider>
  );
};

export default BackOfficeSideMenu;
